import React from 'react';
import { useEffect, useState } from "react";

import { Container } from 'react-bootstrap';
import { useLocation } from "react-router-dom";

// import Breadcrumbs from '../components/Breadcrumbs';
import SchemeListNew from '../features/schemes/SchemeListNew';

export default function UserSchemesWatchList({ filters = []}) {
  const location = useLocation();
  const [watchListURL, setWatchListURL] = useState('/my-schemes-watchlist');

  const watchlistParam = (location.state?.watchlistName) ? {'watchlistName' : (location.state?.watchlistName) }: null

  useEffect(() => {
    if (!watchlistParam) {
      setWatchListURL('/my-schemes-watchlist');
      return;
    }
    setWatchListURL('/my-schemes-watchlist')
    return;
  }, []);

  return (
    <div className="container-fluid" >
      <SchemeListNew filters={filters} apiURL={watchListURL} urlParams={watchlistParam} 
                     originatorInfo={{'isAncestorWatchlist' : true, 'watchlistName': location.state?.watchlistName }}
                     isAddToWatchlistApplicable={false} isDeleteFromWatchlistApplicable={true}
                     schemeListTitle="User's Scheme WatchList -"/>
    </div>
  );
}